import Shuffle from 'shufflejs';

export default class Filter {
  constructor () {
    this.init(document.querySelector('#js-shop-list'));
  };

  /**
   * shuffle.js 初期化
   * @param {*} element
   */
  init(element) {
    if (element) {
      this.prefectures = Array.from(document.querySelectorAll('#js-prefecture-filter input'));
      this.brands = Array.from(document.querySelectorAll('#js-brand-filter input'));
      this.shuffle = new Shuffle(element, {
        itemSelector: '.c-shop__item'
      });

      this.filters = {
        prefectures: [],
        brands: [],
      };

      this._bindEventListeners();
    }
  };

  /**
   * イベントリスナー
   */
  _bindEventListeners() {
    this._onPrefectureChange = this._handlePrefectureChange.bind(this);
    this._onBrandChange = this._handleBrandChange.bind(this);

    this.prefectures.forEach((input) => {
      input.addEventListener('change', this._onPrefectureChange);
    });
    this.brands.forEach((input) => {
      input.addEventListener('change', this._onBrandChange);
    });
  };

  /**
   * 都道府県フィルター
   */
  _handlePrefectureChange() {
    let prefectures = this._getCurrentFilters(this.prefectures);
    if (prefectures == '') {
      this.filters.prefectures = [];
    } else {
      this.filters.prefectures = prefectures;
    }

    this.filter();
  };

  /**
   * ブランドフィルター
   */
  _handleBrandChange() {
    let brands = this._getCurrentFilters(this.brands);
    if (brands == '') {
      this.filters.brands = [];
    } else {
      this.filters.brands = brands;
    }

    this.filter();
  };

  _getCurrentFilters(elements) {
    return elements.filter((input) => {
      return input.checked;
    }).map((input) => {
      return input.value;
    });
  };

  filter() {
    if (this.hasActiveFilters()) {
      this.shuffle.filter(this.itemPassesFilters.bind(this));
    } else {
      this.shuffle.filter(Shuffle.ALL_ITEMS);
    }
  };

  hasActiveFilters() {
    const { prefectures, brands } = this.filters;
    return prefectures.length > 0 || brands.length > 0;
  };

  itemPassesFilters(element){
    const checks = [];
    const { prefectures, brands } = this.filters;

    if (prefectures.length > 0) {
      checks.push(this.matchesPrefecture(element));
    }

    if (brands.length > 0) {
      checks.push(this.matchesBrand(element));
    }

    return checks.every((element) => {
      return element;
    });
  };

  matchesPrefecture(element) {
    const elementPrefecture = element.dataset.prefecture;
    return !!elementPrefecture && this.filters.prefectures.includes(elementPrefecture);
  };

  matchesBrand(element) {
    const elementBrand = element.dataset.brand;
    return !!elementBrand && this.filters.brands.includes(elementBrand);
  };
}
